document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('.thumbnail-list__item[data-variant-id]');
    if (!thumb) return;

    const variantId = thumb.dataset.variantId;
    if (!variantId) return;

    const variantSelects = document.querySelector('variant-selects');
    if (!variantSelects) return;

    const productHandle = window.location.pathname.split('/products/')[1]?.split('?')[0];
    if (!productHandle) return;

    fetch(`/products/${productHandle}.js`)
      .then(r => r.json())
      .then(product => {
        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;

        // Group radios by trimmed name, preserving order
        const radioMap = {};
        variantSelects.querySelectorAll('input[type="radio"]').forEach(input => {
          const key = input.name.trim();
          if (!radioMap[key]) radioMap[key] = [];
          radioMap[key].push(input);
        });
        const radioGroups = Object.values(radioMap); // array of arrays, in option order

        variant.options.forEach((optionValue, index) => {
          // Find matching radio by value comparison (no selector needed)
          const group = radioGroups[index];
          if (group) {
            const radio = group.find(i => i.value === optionValue);
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
              return;
            }
          }

          // Fallback: try select by index
          const selects = [...variantSelects.querySelectorAll('select')];
          const select = selects[index];
          if (select && select.value !== optionValue) {
            select.value = optionValue;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
  });
});
